export default function () {
  const buttons = document.querySelectorAll('.blog__button--load-more');
  const postsBlocks = document.querySelectorAll('.blog__posts');
  const postsBlock = postsBlocks[postsBlocks.length - 1];

  if (buttons) {
    buttons.forEach((button) => {
      let { page } = button.dataset;
      button.addEventListener('click', () => {
        if (!button.classList.contains('blog__button--loading')) {
          button.classList.add('blog__button--loading');
          button.setAttribute('disabled', 'disabled');
          page++;

          fetch('/wp-json/azds/v1/posts/', {
            method: 'POST',
            body: JSON.stringify({
              page,
              category: parseInt(button.dataset.categoryId, 10),
            }),
            headers: {
              'Content-type': 'application/json; charset=UTF-8',
            },
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.last_page) {
                button.parentElement.remove();
              } else {
                button.classList.remove('blog__button--loading');
                button.removeAttribute('disabled');
              }

              if (postsBlock && data.html) {
                postsBlock.insertAdjacentHTML('beforeEnd', data.html);
              }
            });
        }
      });
    });
  }
}
